import moment from "moment";
import { Module } from "vuex";
import { RootState } from "@/store";

import state, { LicenseState } from "./state";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export default {
    state,
    mutations,
    actions,
    getters,
} as Module<LicenseState, RootState>;
